import { Link, useNavigate, useSearch } from "@tanstack/react-router";
import { useEffect } from "react";

export function BrandPickerPage() {
  const navigate = useNavigate();
  const search = useSearch({ strict: false }) as { cap?: string };

  // Legacy redirect: /?cap=X -> /hers/X
  useEffect(() => {
    if (search.cap) {
      navigate({
        to: "/$brand/$cat",
        params: { brand: "hers", cat: search.cap },
        replace: true,
      });
    }
  }, [search.cap, navigate]);

  if (search.cap) return null;

  return (
    <div className="flex min-h-screen items-center justify-center bg-background p-6">
      <div className="flex w-full max-w-lg flex-col items-center gap-8">
        <h1 className="text-2xl font-semibold text-foreground">Choose your experience</h1>
        <div className="flex w-full flex-col gap-4 sm:flex-row">
          <Link
            to="/$brand"
            params={{ brand: "hims" }}
            className="flex flex-1 flex-col items-center justify-center gap-3 rounded-2xl border-2 border-[#e5dacf] bg-[#faf8f2] p-10 transition-all hover:border-[#a0754a]/60 hover:shadow-lg focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-[#a0754a]"
            aria-label="Enter hims experience"
          >
            <span className="text-3xl font-bold tracking-tight text-[#5a4a3a]">hims</span>
            <span className="text-sm text-[#5a4a3a]/60">Men&apos;s health &amp; wellness</span>
          </Link>
          <Link
            to="/$brand"
            params={{ brand: "hers" }}
            className="flex flex-1 flex-col items-center justify-center gap-3 rounded-2xl border-2 border-[#d3e0db] bg-[#f5faf6] p-10 transition-all hover:border-[#223c47]/40 hover:shadow-lg focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-[#223c47]"
            aria-label="Enter hers experience"
          >
            <span className="text-3xl font-bold tracking-tight text-[#223c47]">hers</span>
            <span className="text-sm text-[#223c47]/60">Women&apos;s health &amp; wellness</span>
          </Link>
        </div>
      </div>
    </div>
  );
}
